import { useDefaultSavedHandlers } from "@/controller/defaultSavedHandlers";
import Edit from "@/controller/Edit";
import WithSave from "@/controller/WithSave";
import { ClientManageDto } from "@/gen/api/user";
import { Grid, Typography, FormControlLabel, Checkbox, FormGroup, Skeleton } from "@mui/material";
import { useEditContext, useRecordContext } from "ra-core";
import { FC, useEffect, useState } from "react";


const res = 'settings-clients-securefile-serveredition'

const ServerEditionSecureFileTag: FC<{
  record: ClientManageDto
}> = ({
  record,
}) => {
  const handler = useDefaultSavedHandlers("Save Setting")
  return (
    <Edit resource={res} basePath="" id={record.clientId!} mutationMode="pessimistic" {...handler}>
      <ServerEditionSecureFileTagBody />
    </Edit>
  )
}

const ServerEditionSecureFileTagBody: FC = () => {
  const rcCtx = useRecordContext()
  const isServerEdition : boolean = rcCtx?.isServerEdition || false;
  const [checked, setChecked] = useState(isServerEdition)
  useEffect(() => {
    setChecked(isServerEdition)
  }, [isServerEdition])
  console.log({ rcCtx, isServerEdition, checked})
  const { loaded, loading, refetch } = useEditContext()
  const handleSave = (save: (isServerEdition: boolean)=>Promise<void>) => async (e:any, checked: boolean) => {
    try {
      await save(checked)
      setChecked(checked)
      refetch?.()
    } catch {
      // do nothing...
    }
  }
  return (
    <>
      <Grid item xs={6} sx={{ ml: 'auto' }} >
        {!loaded 
        ? <Skeleton />
        : <WithSave async render={({save, saving}) =>
            <FormGroup>
              <FormControlLabel 
                label={loading || saving 
                  ? <span>Is Server Computer {<Typography variant="caption" color="text.secondary">(saving...)</Typography>}</span> 
                  : "Is Server Computer" }
                control={
                  <Checkbox 
                    disabled={loading || saving}
                    checked={checked}
                    onChange={handleSave(save)}
                    inputProps={{ 'aria-label': 'controlled' }}
                  />} 
              />
            </FormGroup>
          } />
        }
      </Grid>
    </>
  )
}

export default ServerEditionSecureFileTag;
